import { render, staticRenderFns } from "./SupportComponent.vue?vue&type=template&id=f18f9b58&scoped=true"
import script from "./SupportComponent.vue?vue&type=script&lang=js"
export * from "./SupportComponent.vue?vue&type=script&lang=js"
import style0 from "./SupportComponent.vue?vue&type=style&index=0&id=f18f9b58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18f9b58",
  null
  
)

export default component.exports